import { useState } from "react";
import { api } from "../lib/api";
import { useToast } from "../context/ToastContext";

const TOPICS = [
  "General enquiry",
  "Diabetes & blood sugar",
  "Heart & blood pressure",
  "Immunity & detox",
  "Men's / Women's health",
  "Weight management",
  "Other concern",
];

export default function Contact({ settings }) {
  const toast = useToast();
  const [form, setForm] = useState({ name: "", phone: "", topic: TOPICS[0], message: "" });
  const [submitting, setSubmitting] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async () => {
    setSubmitting(true);
    try {
      await api.createContact(form); // persist to DB
    } catch {
      // Still let them reach us on WhatsApp even if persistence fails.
    } finally {
      setSubmitting(false);
    }
    toast("Message saved — opening WhatsApp");
    const text =
      `Hello Green World Nature Pride Healthcare! 🌿\n\n` +
      `Name: ${form.name || "(no name)"}\n` +
      `Phone: ${form.phone}\n` +
      `Topic: ${form.topic}\n\n${form.message}`;
    window.open(`https://wa.me/${settings.whatsapp}?text=${encodeURIComponent(text)}`, "_blank");
  };

  return (
    <section id="contact" className="section contact">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">Reach us</span>
          <h2>Get in touch &amp; order</h2>
          <p>
            Have a question about a product or which package fits you? Send us a message — we're happy to advise.
          </p>
        </div>
        <div className="contact-wrap">
          <div className="contact-info">
            <h3>Contact details</h3>
            <div className="contact-line">
              <i className="fa-solid fa-phone" />
              <div>
                <b>Call / WhatsApp</b>
                <span>{settings.phone_display}</span>
              </div>
            </div>
            <div className="contact-line">
              <i className="fa-solid fa-envelope" />
              <div>
                <b>Email</b>
                <span>{settings.email}</span>
              </div>
            </div>
            <div className="contact-line">
              <i className="fa-solid fa-location-dot" />
              <div>
                <b>Location</b>
                <span>{settings.address}</span>
              </div>
            </div>
            <div className="contact-line">
              <i className="fa-solid fa-clock" />
              <div>
                <b>Hours</b>
                <span>Mon–Sat: 8:00 AM – 6:00 PM</span>
              </div>
            </div>
            <div className="pay-box">
              <span className="eyebrow">Pay with M-Pesa</span>
              <h4>
                Paybill <span>{settings.mpesa_paybill}</span>
              </h4>
              <p>Account: 8083447 — or pay instantly at checkout with an M-Pesa STK push.</p>
            </div>
          </div>

          <div className="contact-form">
            <h3>Send a message</h3>
            <p>We'll get back to you as soon as we can.</p>
            <div className="fg">
              <label>Full name</label>
              <input type="text" value={form.name} onChange={set("name")} placeholder="Your name" />
            </div>
            <div className="fg">
              <label>Phone number</label>
              <input type="tel" value={form.phone} onChange={set("phone")} placeholder="07xx xxx xxx" />
            </div>
            <div className="fg">
              <label>What can we help with?</label>
              <select value={form.topic} onChange={set("topic")}>
                {TOPICS.map((t) => (
                  <option key={t}>{t}</option>
                ))}
              </select>
            </div>
            <div className="fg">
              <label>Message</label>
              <textarea
                rows="4"
                value={form.message}
                onChange={set("message")}
                placeholder="Tell us a little about what you're looking for…"
              />
            </div>
            <button onClick={submit} disabled={submitting}>
              <i className="fa-brands fa-whatsapp" /> {submitting ? "Sending…" : "Send via WhatsApp"}
            </button>
          </div>
        </div>

        <div className="map-block">
          <div className="map-head">
            <div>
              <h3>Find us</h3>
              <p>Visit our shop or get turn-by-turn directions.</p>
            </div>
            <a className="btn btn-gold" href={settings.maps_directions} target="_blank" rel="noopener">
              <i className="fa-solid fa-diamond-turn-right" /> Get directions
            </a>
          </div>
          <div className="map-frame">
            <iframe
              src={settings.maps_embed}
              title="Our location on Google Maps"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
}
